import CoinflipBoardResult from '@/components/Coinflip/Content/Board/Result';
import { CoinSide } from '@/models/bet/coinflip/side';
import { Image } from '@starsoft/common/components';
import { GameReportBoardBet } from '../props';
import styles from './styles.module.scss';

export default function CoinFlipGameBoard({ bet }: GameReportBoardBet) {
  const side: CoinSide | undefined =
    bet?.coinflipBet?.sides[bet?.coinflipBet?.sides.length - 1];
  const tailImage = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/coinflip/tail.svg`;
  const headImage = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/coinflip/head.svg`;

  const payout = bet?.payout;
  const won = payout?.toNumber() > 0;

  function getImage(): string {
    if (won) {
      switch (side) {
        case CoinSide.Heads:
          return headImage;
        case CoinSide.Tails:
          return tailImage;
      }
    }

    switch (side) {
      case CoinSide.Heads:
        return tailImage;
      case CoinSide.Tails:
        return headImage;
    }
  }

  return (
    <div className={styles.container}>
      <Image
        className={styles['container__coin']}
        src={getImage()}
        alt="coin"
        width={100}
        height={100}
      />

      <CoinflipBoardResult sides={bet?.coinflipBet?.sides ?? []} secondary />
    </div>
  );
}
